import React from 'react';
import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

import theme from '@/styles/theme';

interface WrapperProps {
  isChecked: boolean;
}

const Wrapper = styled(Box)<WrapperProps>`
  border: ${({ isChecked, theme }) => isChecked ? `2px solid ${theme.colors.border1}` : '2px solid transparent'};
  box-shadow: ${({ isChecked, theme }) => {
    if (!isChecked) {
      return `0 0 0 1px ${theme.colors.border1}`;
    }
    return 'none';
  }};
  &:hover {
    border: 2px solid ${theme.colors.border1};
    box-shadow: none;
  }
`;

interface Props {
  children: React.ReactNode;
  isChecked: boolean;
}

const TableItemWrapper: React.FC<Props> = ({ children, isChecked }) => {
  return (
    <Wrapper
      background="canvas"
      round="container1Round"
      isChecked={isChecked}
      pad={{ horizontal: 'm', vertical: 'm' }}
    >
      {children}
    </Wrapper>
  );
};

export default TableItemWrapper;
